import React from "react";
import "./Footer.css";
import logo from "../../Assets/logo.png";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

import { Link } from "react-router-dom";

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    alert("Subscribed Successfully");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getCurrentYear = () => new Date().getFullYear();

  return (
    <>
      <footer className="footer">
        <div className="footer__container">
          <div className="footer_left">
            <div className="footer_logo_container">
              <img src="imgs/logo.png" alt="" Z />
            </div>
            <p>TR ALPHA FOCUS,VL.SELIMOVIĆ VEDAD SREBRENIK</p>
            <p>ID broj: 4311663900005</p>
            <p>Ulica 1. Marta , Srebrenik, Bosnia and Herzegovina, 75350</p>

            <div className="footer_address">
              <strong> optika.alpha@gmail.com </strong>
              <strong> +387603317696 </strong>
            </div>

            <div className="social_links">
              <FaFacebookF onClick={() => { window.location.href = "https://www.facebook.com/OptikaAlphaFocusSrebrenik" }} />
              <FaInstagram onClick={() => { window.location.href = "https://www.instagram.com/alphafocus_srebrenik/" }} />
            </div>
          </div>

          <div className="footer_content">
            <h5>Kompanija</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/about">O nama</Link>
                </li>
                <li>
                  <Link to="/contact">Kontakt</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h5>Proizvodi</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/shop">Katalog</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h5>Pomoć</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/loginSignUp">Prijavi se</Link>
                </li>
                <li>
                  <Link to="/contact">Pronađi nas</Link>
                </li>
                <li>
                  <Link to="/terms">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer_right">
            <h6>Sigurna kartična plaćanja</h6>
            <div className="paymentIconContainer">
              <img onClick={() => {
                window.open("http://monri.com/", "_blank", "noopener,noreferrer");
              }} src="/imgs/CardLogos/monri.png" alt="Monri" />
              <img onClick={() => {
                window.open("https://www.visa.com", "_blank", "noopener,noreferrer");
              }} src="/imgs/CardLogos/visa.jpg" alt="Visa" />
              <img onClick={() => {
                window.open("https://www.mastercard.com", "_blank", "noopener,noreferrer");
              }} src="/imgs/CardLogos/mastercard.png" alt="Mastercard®" />
              <img onClick={() => {
                window.open("https://brand.mastercard.com/brandcenter/more-about-our-brands.html", "_blank", "noopener,noreferrer");
              }} src="/imgs/CardLogos/maestro.png" alt="Maestro®" />
              <img onClick={() => {
                window.open("https://www.mastercard.com", "_blank", "noopener,noreferrer");
              }} src="/imgs/CardLogos/mastercardIDcheck.png" alt="Mastercard®" />
              <img onClick={() => {
                window.open("https://www.visa.com", "_blank", "noopener,noreferrer");
              }} src="/imgs/CardLogos/visasecure.jpg" alt="Visa" />
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <p>
            © {getCurrentYear()} Alpha Focus. Sva prava zadržana | Shop napravio{" "}
            <a
              href="https://virtusinno.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#C22928", textDecoration: "none" }}
            >
              Virtus Inno d.o.o.
            </a>
          </p>
          <div className="footerLangCurrency">
            <div className="footerLang">
              <p>Jezik</p>
              <select name="language" id="language">
                <option value="bosnian">Bosanski</option>
                <option value="english">Engleski</option>
                <option value="greman">Njemački</option>
                <option value="franch">Francuski</option>
                <option value="slovenian">Slovenski</option>
              </select>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
